import { makeRequest } from "../utils/api";

export const getCategories = (queryParams = "") => {
  return makeRequest(
    `/categories/${queryParams ? "?" + queryParams : ""}`,
    "GET"
  );
};

export const createCategory =
  (setError) =>
  ({ name, color }) => {
    return makeRequest(
      "/categories",
      "POST",
      { name, color: color?.hex },
      false,
      setError
    );
  };

export const updateCategory =
  (setError) =>
  ({ id, name, color: { hex } }) => {
    return makeRequest(
      `/categories/${id}/`,
      "PUT",
      { name, color: hex },
      false,
      setError
    );
  };

export const deleteCategory = ({ id }) => {
  return makeRequest(`/categories/${id}`, "DELETE");
};
